import { useEffect, useState } from "react";
import { Ticket, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatErr } from "@/lib/api";

export function LottoAdmin() {
  const [d, setD] = useState(null);
  const [val, setVal] = useState("");
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/admin/lotto/jackpot").then(({ data }) => { setD(data); setVal(String(data.jackpot)); });
  useEffect(() => { load(); }, []);
  const save = async (v) => {
    const n = Number(v);
    if (!Number.isInteger(n) || n < 0) return toast.error("Bitte eine ganze Zahl ab 0 eingeben");
    if (!window.confirm(`Lotto-Jackpot wirklich auf ${n.toLocaleString("de-DE")} Punkte setzen?`)) return;
    setBusy(true);
    try { await api.put("/admin/lotto/jackpot", { jackpot: n }); toast.success("Jackpot gespeichert"); await load(); }
    catch (e) { toast.error(formatErr(e)); } finally { setBusy(false); }
  };
  if (!d) return <div className="flex justify-center py-10"><Loader2 className="w-6 h-6 animate-spin text-rose-500" /></div>;
  return (
    <div className="bg-white rounded-3xl p-6 border border-pink-100 max-w-xl space-y-4" data-testid="lotto-admin">
      <p className="font-bold flex items-center gap-2"><Ticket className="w-5 h-5 text-rose-500" /> Lotto-Jackpot</p>
      <p className="text-4xl font-extrabold text-rose-600" data-testid="lotto-admin-current">{d.jackpot.toLocaleString("de-DE")} <span className="text-base text-slate-500">Punkte</span></p>
      <p className="text-sm text-slate-500">Nach jedem Jackpot-Gewinn startet der Topf bei 0. Alle {d.mark.toLocaleString("de-DE")} Punkte bekommen alle Nutzer eine Push und eine Benachrichtigung.</p>
      <div className="flex flex-wrap gap-2">
        <input type="number" min="0" value={val} onChange={(e) => setVal(e.target.value)} data-testid="lotto-admin-input" className="h-11 w-40 px-4 rounded-full border border-pink-200 focus:outline-none focus:ring-2 focus:ring-rose-300" />
        <button onClick={() => save(val)} disabled={busy} data-testid="lotto-admin-save" className="h-11 px-6 rounded-full bg-rose-500 text-white font-bold text-sm disabled:opacity-50">Jackpot setzen</button>
        <button onClick={() => save(0)} disabled={busy} data-testid="lotto-admin-reset" className="h-11 px-5 rounded-full border border-pink-200 text-rose-600 font-bold text-sm disabled:opacity-50">Auf 0 setzen</button>
      </div>
    </div>
  );
}
